<div tabindex="-1" role="dialog">
  <div>
    <div class="modal-header">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.close(false)">
        <span aria-hidden="true">X</span>
      </button>
    </div>
    <div>
      <div class="video-container">
        <video #video id="video" [width]="WIDTH" [height]="HEIGHT" autoplay></video>
        <canvas style="display: none;" #canvas id="canvas" [width]="WIDTH" [height]="HEIGHT"></canvas>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="capture()">Tirar Foto</button>
    </div>
  </div>
</div>